import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonGroup = ({ children, gap = 2, className = '', dataTestId }) => {
    const isNumericGap = typeof gap === 'number';
    const gapClass = isNumericGap ? `nucleus-gap-${gap}` : '';
    const gapStyle = !isNumericGap ? { gap } : undefined;
    return (_jsx("div", { "data-testid": dataTestId, className: `nucleus-flex nucleus-flex-col ${gapClass} ${className}`, style: gapStyle, children: children }));
};
//# sourceMappingURL=skeleton_group.component.js.map